export default "dist/images/block-container-image.f5fcb5d.png";